export default __webpack_public_path__ + "static/media/setting.0c5bfe1b.svg";